import React from 'react';
import cn from 'classnames';
import Slider from '@wix/da-ds/pkg/Slider';
import Dumbo from '../../../DeviationViews/Dumbo';
import Attachment from '../../../DeviationViews/Attachment';
import s from './AdditionalImages.scss';
const THUMB_SIZE = 40;
const AdditionalImages = ({ className, deviation, selected, onSelect })=>{
    var _deviation_extended;
    const attachments = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.additionalMedia;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, /*#__PURE__*/ React.createElement(Slider, {
        slimSpacing: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['thumb'], !selected && s['selected']),
        onClick: ()=>onSelect(null)
    }, /*#__PURE__*/ React.createElement(Dumbo, {
        deviation: deviation,
        width: THUMB_SIZE,
        height: THUMB_SIZE
    })), attachments.map((attachment, idx)=>/*#__PURE__*/ React.createElement(Attachment, {
            key: `attachment-${idx}`,
            className: cn(s['thumb'], selected === attachment && s['selected']),
            attachment: attachment,
            width: THUMB_SIZE,
            height: THUMB_SIZE,
            onSelect: onSelect
        }))));
};
AdditionalImages.displayName = 'AdditionalImages';
export default AdditionalImages;

//# sourceMappingURL=AdditionalImages.js.map